import type { SolutionProcessTrpcApi } from '@ipen-portal/plugin-solution-process-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const jiraApiRef = createApiRef<
  TRPCOptionsProxy<SolutionProcessTrpcApi>
>().with({
  id: 'plugin.ipen.jira.api',
});
